export class AtualizarGtinProdutoRequest {
  public idProduto: number = 0;
  public gtinEan: string = '';
}
